import api from "../axios";
import Api from "../Api";

export async function createPrivateSale(ArrayData) {
  const response = await api
    .post(`${Api.request.URL}/private-sale/`, ArrayData)
    .then((res) => {
      // console.log("data data: ", res.data);
      return res.data;
    })
    .catch((error) => {
      return error.response.data.errors;
    });
  return response;
}

// export async function getGroup() {
//     const response = await api
//       .get(`${Api.request.URL}/private-sale-group/`)
//       .then((res) => {
//         // console.log("data data: ", res.data);
//         return res.data.data;
//       })
//       .catch((error) => {
//         return error.response.data.errors;
//       });
//     return response;
//   }





export async function UpdatePrivateSale(id, ArrayData) {
  const response = await api
    .put(`${Api.request.URL}/private-sale/${id}`, ArrayData)
    .then((res) => {
      // console.log("data data: ", res.data);
      return res.data.msg;
    })
    .catch((error) => {
      return error.response.data.errors;
    });
  return response; 
}
// SA adminModel/privateSale.js
export async function privateList({ keyword = "", group = "PRIVATE_SALE", id = "", start = 0, limit = 20 } = {}) {
  try {
    const response = await api.get(
      `${Api.request.URL}/private-sale`, 
      {
        params: {
          private_sale_group: group,
          search: keyword, // Ipinasa ang keyword sa search
          title: keyword,  // Ipinasa rin ang kaparehong keyword sa title
          category: "",
          medium: "",
          start: start,
          limit: limit,
          exhibit: id
        }
      }
    );

    return response?.data?.data || [];
  } catch (error) {
    console.error("API Error sa privateList:", error);
    return [];
  }
}

export async function getFindById(id) {
  const response = await api
    .get(`${Api.request.URL}/private-sale/${id}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      return error.response.data.errors;
    });
  return response;
}


export async function exhibitionList(id,keyword,start,limit) {
  try {
    const response = await api.get(
      `${Api.request.URL}/private-sale`, 
      {
        params: {
          private_sale_group: "EXHIBITION",
          search: keyword, // Ipinasa ang keyword sa search
          title: keyword,  // Ipinasa rin ang kaparehong keyword sa title
         
          start: start,
          limit: limit,
          exhibit: id
        }
      }
    );

    return response?.data?.data || [];
  } catch (error) {
    console.error("API Error sa privateList:", error);
    return [];
  }
}